/**
 * @generated SignedSource<<43d3095420bde7f9caae9829761a3fef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type FieldEditorsFieldTextValue$data = {
  readonly field: {
    readonly id?: string;
    readonly name?: string;
  };
  readonly id: string;
  readonly value: string;
  readonly " $fragmentType": "FieldEditorsFieldTextValue";
};
export type FieldEditorsFieldTextValue$key = {
  readonly " $data"?: FieldEditorsFieldTextValue$data;
  readonly " $fragmentSpreads": FragmentRefs<"FieldEditorsFieldTextValue">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FieldEditorsFieldTextValue",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "field",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "type": "IssueFieldText",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ],
  "type": "IssueFieldTextValue",
  "abstractKey": null
};
})();

(node as any).hash = "66816d640ad6c07685c8482ba4369517";

export default node;
